// extracted by mini-css-extract-plugin
export default {"commentBox":"vxaeva","withPadding":"h9TFJs"};